import { Link } from "react-router-dom";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

function PatientVisitorGuide() {
	const { visibleSections, addToRefs } = useScrollAnimation();

	return (
		<>
			{/* Hero Section with Image */}
			<div className="container-fluid px-0">
				<div className="row g-0">
					<div className="col-12">
						<div
							style={{
								position: "relative",
								height: "500px",
								overflow: "hidden",
							}}>
							<img
								src="/img/carousel/physio.jpg"
								alt="Tema General Hospital"
								style={{
									width: "100%",
									height: "100%",
									objectFit: "cover",
								}}
							/>
							<div
								style={{
									position: "absolute",
									bottom: 0,
									left: 0,
									right: 0,
									background:
										"linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
									padding: "60px 0 40px",
								}}>
								<div className="container">
									<h1
										className="text-white mb-3"
										style={{
											fontSize: "3.5rem",
											fontWeight: "bold",
											lineHeight: "1.2",
										}}>
										Patient & Visitor Guide
									</h1>
									<p
										className="text-white mb-0"
										style={{ fontSize: "1.25rem", maxWidth: "600px" }}>
										Your guide to getting care at Tema General Hospital
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Main Content */}
			<div
				className="container py-5 patient-visitor-guide"
				style={{ maxWidth: "1200px" }}>
				{/* About Tema General Hospital */}
				<div
					ref={(el) => addToRefs(el, 0)}
					className={`scroll-fade-in ${visibleSections.has(0) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row align-items-start">
						<div className="col-lg-6 mb-4 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								About Tema General Hospital
							</h2>
							<p
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
									marginBottom: "2rem",
								}}>
								Tema General Hospital is a public healthcare facility committed
								to providing quality, compassionate, and affordable healthcare
								services to the community. We offer a wide range of outpatient,
								inpatient, emergency, and specialist services delivered by
								trained healthcare professionals.
							</p>
						</div>
						<div className="col-lg-6">
							<img
								src="/img/carousel/opdmain.jpg"
								alt="Tema General Hospital"
								className="img-fluid rounded"
								style={{ width: "100%", height: "auto" }}
							/>
						</div>
					</div>
				</div>

				{/* Getting to the Hospital */}
				<div
					ref={(el) => addToRefs(el, 1)}
					className={`scroll-fade-in ${visibleSections.has(1) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row align-items-start">
						<div className="col-lg-6 mb-4 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Getting to the Hospital
							</h2>
							<div className="d-flex flex-column gap-3">
								<div className="p-3 border-bottom">
									<h5
										style={{
											fontSize: "1.2rem",
											fontWeight: "600",
											color: "#000",
											marginBottom: "0.5rem",
										}}>
										Location
									</h5>
									<a
										href="https://maps.app.goo.gl/fYCxAzFS3JNGUKnNA"
										target="_blank"
										rel="noopener noreferrer"
										style={{
											fontSize: "1.1rem",
											color: 'var(--tgh-blue-light)',
											textDecoration: "none",
											marginBottom: 0,
										}}>
										Tema Community 12
									</a>
								</div>
								<div className="p-3 border-bottom">
									<h5
										style={{
											fontSize: "1.2rem",
											fontWeight: "600",
											color: "#000",
											marginBottom: "0.5rem",
										}}>
										Access
									</h5>
									<p
										style={{
											fontSize: "1.1rem",
											color: "#333",
											marginBottom: 0,
										}}>
										The hospital is accessible by public transport, taxis, and
										private vehicles.
									</p>
								</div>
								<div className="p-3">
									<h5
										style={{
											fontSize: "1.2rem",
											fontWeight: "600",
											color: "#000",
											marginBottom: "0.5rem",
										}}>
										Parking
									</h5>
									<p
										style={{
											fontSize: "1.1rem",
											color: "#333",
											marginBottom: 0,
										}}>
										Designated parking areas are available for patients and
										visitors. Please follow posted signs and security
										instructions.
									</p>
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="row g-3">
								<div className="col-md-6">
									<img
										src="/img/carousel/admin2.jpg"
										alt="TGH Campus"
										className="img-fluid rounded"
										style={{
											width: "100%",
											height: "200px",
											objectFit: "cover",
										}}
									/>
								</div>
								<div className="col-md-6">
									<img
										src="/img/carousel/peripal.jpg"
										alt="TGH Facilities"
										className="img-fluid rounded"
										style={{
											width: "100%",
											height: "200px",
											objectFit: "cover",
										}}
									/>
								</div>
								<div className="col-md-6">
									<img
										src="/img/carousel/physio.jpg"
										alt="TGH Services"
										className="img-fluid rounded"
										style={{
											width: "100%",
											height: "200px",
											objectFit: "cover",
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Hospital Departments & Services */}
				<div
					ref={(el) => addToRefs(el, 2)}
					className={`scroll-fade-in ${visibleSections.has(2) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<h2
						className="mb-4"
						style={{
							fontSize: "2.5rem",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontFamily: "Georgia, serif",
							lineHeight: "1.2",
						}}>
						Hospital Departments & Services
					</h2>
					<div className="row">
						<div className="col-lg-6 mb-4 mb-lg-0">
							<h3
								className="mb-3"
								style={{
									fontSize: "1.5rem",
									fontWeight: "600",
									color: "#000",
								}}>
								Clinical Services
							</h3>
							<div className="d-flex flex-column gap-2 mb-3">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Outpatient Department (OPD)
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Emergency & Casualty Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Inpatient/Ward Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Maternity & Child Health
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Surgical Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Medical Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Paediatrics
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Pharmacy Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Laboratory & Diagnostic Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Radiology/Imaging
								</p>
							</div>
							<Link
								to="/services"
								className="btn btn-primary"
								style={{
									backgroundColor: 'var(--tgh-blue-light)',
									borderColor: 'var(--tgh-blue-light)',
									color: "#fff",
									padding: "10px 24px",
									fontSize: "1rem",
									fontWeight: "500",
									borderRadius: "4px",
									textDecoration: "none",
									display: "inline-block",
									transition: "all 0.3s ease",
								}}
								onMouseEnter={(e) => {
									e.target.style.backgroundColor = "var(--tgh-blue)";
									e.target.style.borderColor = "var(--tgh-blue)";
								}}
								onMouseLeave={(e) => {
									e.target.style.backgroundColor = "var(--tgh-blue-light)";
									e.target.style.borderColor = "var(--tgh-blue-light)";
								}}>
								View More
							</Link>
						</div>
						<div className="col-lg-6">
							<h3
								className="mb-3"
								style={{
									fontSize: "1.5rem",
									fontWeight: "600",
									color: "#000",
								}}>
								Support Services
							</h3>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Health Information / Records
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Accounts & Billing
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Security Services
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Environmental & Sanitation Services
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Patient Registration & Records */}
				<div
					ref={(el) => addToRefs(el, 3)}
					className={`scroll-fade-in ${visibleSections.has(3) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row align-items-start">
						<div className="col-lg-6 mb-4 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Patient Registration & Records
							</h2>
							<p
								className="mb-4"
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
								}}>
								All patients must register at the{" "}
								<strong>Outpatient Department (OPD)</strong> or{" "}
								<strong>Health Information Unit</strong>.
							</p>
							<h3
								className="mb-3"
								style={{
									fontSize: "1.3rem",
									fontWeight: "600",
									color: "#000",
								}}>
								Please present:
							</h3>
							<div className="d-flex flex-column gap-2 mb-4">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• National Health Insurance Scheme (NHIS) card{" "}
									<strong>or</strong>
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Valid ID (if applicable)
								</p>
							</div>
							<p
								style={{
									fontSize: "1.1rem",
									color: "#333",
									fontStyle: "italic",
								}}>
								Returning patients should bring their hospital card or folder.
							</p>
						</div>
						<div className="col-lg-6">
							<img
								src="/img/carousel/labb.jpeg"
								alt="Patient Registration"
								className="img-fluid rounded"
								style={{ width: "100%", height: "auto" }}
							/>
						</div>
					</div>
				</div>

				{/* Visiting the Outpatient Department (OPD) */}
				<div
					ref={(el) => addToRefs(el, 4)}
					className={`scroll-fade-in ${visibleSections.has(4) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<h2
						className="mb-4"
						style={{
							fontSize: "2.5rem",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontFamily: "Georgia, serif",
							lineHeight: "1.2",
						}}>
						Visiting the Outpatient Department (OPD)
					</h2>
					<div className="row mb-4">
						<div className="col-md-3 mb-3 mb-md-0">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<div
									className="mb-3"
									style={{
										fontSize: "3rem",
										color: 'var(--tgh-blue-light)',
										fontWeight: "bold",
									}}>
									1
								</div>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Register
								</h4>
								<p style={{ fontSize: "1rem", color: "#333", marginBottom: 0 }}>
									Register at the OPD/Records Unit
								</p>
							</div>
						</div>
						<div className="col-md-3 mb-3 mb-md-0">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<div
									className="mb-3"
									style={{
										fontSize: "3rem",
										color: 'var(--tgh-blue-light)',
										fontWeight: "bold",
									}}>
									2
								</div>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Consultation
								</h4>
								<p style={{ fontSize: "1rem", color: "#333", marginBottom: 0 }}>
									Proceed to consultation room when called
								</p>
							</div>
						</div>
						<div className="col-md-3 mb-3 mb-md-0">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<div
									className="mb-3"
									style={{
										fontSize: "3rem",
										color: 'var(--tgh-blue-light)',
										fontWeight: "bold",
									}}>
									3
								</div>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Follow Up
								</h4>
								<p style={{ fontSize: "1rem", color: "#333", marginBottom: 0 }}>
									Follow instructions for laboratory tests, pharmacy, or imaging
									if requested
								</p>
							</div>
						</div>
						<div className="col-md-3">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<div
									className="mb-3"
									style={{
										fontSize: "3rem",
										color: 'var(--tgh-blue-light)',
										fontWeight: "bold",
									}}>
									4
								</div>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Payment
								</h4>
								<p style={{ fontSize: "1rem", color: "#333", marginBottom: 0 }}>
									Make payment (if applicable) at the accounts office
								</p>
							</div>
						</div>
					</div>
					<div
						className="p-3"
						style={{ backgroundColor: 'var(--tgh-surface-tint)', borderRadius: "8px" }}>
						<p style={{ fontSize: "1.1rem", color: "#333", marginBottom: 0 }}>
							<strong>Tip:</strong> Arrive early to reduce waiting time.
						</p>
					</div>
				</div>

				{/* Emergency Services */}
				<div
					ref={(el) => addToRefs(el, 5)}
					className={`scroll-fade-in ${visibleSections.has(5) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<h2
						className="mb-4"
						style={{
							fontSize: "2.5rem",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontFamily: "Georgia, serif",
							lineHeight: "1.2",
						}}>
						Emergency Services
					</h2>
					<div className="row">
						<div className="col-lg-8">
							<p
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
									marginBottom: "1rem",
								}}>
								Emergency services are available <strong>24 hours a day</strong>
								.
							</p>
							<p
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
									marginBottom: "1rem",
								}}>
								Patients with life‑threatening conditions are treated
								immediately.
							</p>
							<p
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
									marginBottom: 0,
								}}>
								Kindly cooperate with emergency staff to allow quick and
								effective care.
							</p>
						</div>
					</div>
				</div>

				{/* Inpatient & Ward Admission */}
				<div
					ref={(el) => addToRefs(el, 6)}
					className={`scroll-fade-in ${visibleSections.has(6) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row align-items-start">
						<div className="col-lg-6 mb-4 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Inpatient & Ward Admission
							</h2>
							<h3
								className="mb-3"
								style={{
									fontSize: "1.3rem",
									fontWeight: "600",
									color: "#000",
								}}>
								What to Bring
							</h3>
							<div className="d-flex flex-column gap-2 mb-4">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Personal toiletries
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Basic clothing
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Prescribed medications (if any)
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Valid identification
								</p>
							</div>
							<h3
								className="mb-3"
								style={{
									fontSize: "1.3rem",
									fontWeight: "600",
									color: "#000",
								}}>
								Ward Rules
							</h3>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Follow visiting hours strictly
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Keep noise levels low
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Maintain cleanliness
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Follow nurses' and doctors' instructions at all times
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<img
								src="/img/carousel/recoveryy.png"
								alt="Ward Services"
								className="img-fluid rounded"
								style={{ width: "100%", height: "auto" }}
							/>
						</div>
					</div>
				</div>

				{/* Visiting Hours, Pharmacy, Laboratory, Safety */}
				<div
					ref={(el) => addToRefs(el, 7)}
					className={`scroll-fade-in ${visibleSections.has(7) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row">
						<div className="col-lg-6 mb-5 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Visiting Hours
							</h2>
							<p
								className="mb-4"
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
								}}>
								Visiting hours vary by ward.
							</p>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Confirm visiting times at the nurse's station
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Limit the number of visitors per patient
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Avoid visits if feeling unwell
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Pharmacy Services
							</h2>
							<p
								className="mb-4"
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
								}}>
								Prescriptions issued by hospital clinicians are dispensed at the
								hospital pharmacy.
							</p>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• NHIS and private payments are accepted based on eligibility
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Patients are encouraged to ask questions about medication
									usage before leaving
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Laboratory & Diagnostic Services, Safety & Security */}
				<div
					ref={(el) => addToRefs(el, 8)}
					className={`scroll-fade-in ${visibleSections.has(8) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row">
						<div className="col-lg-6 mb-5 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Laboratory & Diagnostic Services
							</h2>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Patients may be referred for tests such as blood work,
									scans, or X‑rays
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Follow all preparation instructions given by staff
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Results are sent directly to the requesting clinician
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Safety & Security
							</h2>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Security personnel are on duty to ensure safety
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Report any suspicious activity to hospital security
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Keep personal belongings secure at all times
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Patient Rights & Responsibilities */}
				<div
					ref={(el) => addToRefs(el, 9)}
					className={`scroll-fade-in ${visibleSections.has(9) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row">
						<div className="col-lg-6 mb-5 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Patient Rights
							</h2>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Respectful and dignified care
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Privacy and confidentiality
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Clear explanation of diagnosis and treatment
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Participation in healthcare decisions
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Patient Responsibilities
							</h2>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Provide accurate health information
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Follow treatment instructions
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Respect staff and other patients
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Protect hospital property
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Infection Prevention & Complaints */}
				<div
					ref={(el) => addToRefs(el, 10)}
					className={`scroll-fade-in ${visibleSections.has(10) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<div className="row">
						<div className="col-lg-6 mb-5 mb-lg-0">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Infection Prevention & Control
							</h2>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Wash or sanitize hands regularly
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Follow posted hygiene instructions
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Use face masks where required
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Observe cough and sneeze etiquette
								</p>
							</div>
						</div>
						<div className="col-lg-6">
							<h2
								className="mb-4"
								style={{
									fontSize: "2.5rem",
									fontWeight: "bold",
									color: 'var(--tgh-blue-light)',
									fontFamily: "Georgia, serif",
									lineHeight: "1.2",
								}}>
								Complaints & Feedback
							</h2>
							<p
								className="mb-4"
								style={{
									fontSize: "1.1rem",
									color: "#333",
									lineHeight: "1.6",
								}}>
								Patients and visitors are encouraged to share feedback to help
								improve our services.
							</p>
							<div className="d-flex flex-column gap-2">
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Visit the{" "}
									<strong>Public Relations / Complaints Unit</strong>
								</p>
								<p
									style={{
										fontSize: "1.1rem",
										color: "#333",
										marginBottom: 0,
									}}>
									• Speak with the nurse in charge or ward manager
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Important Tips */}
				<div
					ref={(el) => addToRefs(el, 11)}
					className={`scroll-fade-in ${visibleSections.has(11) ? "visible" : ""}`}
					style={{ marginBottom: "80px" }}>
					<h2
						className="mb-4"
						style={{
							fontSize: "2.5rem",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontFamily: "Georgia, serif",
							lineHeight: "1.2",
						}}>
						Important Tips for a Smooth Visit
					</h2>
					<div className="row g-4">
						<div className="col-md-3">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<i
									className="bi bi-clock"
									style={{
										fontSize: "2.5rem",
										color: 'var(--tgh-blue-light)',
										marginBottom: "1rem",
										display: "block",
									}}></i>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Arrive Early
								</h4>
							</div>
						</div>
						<div className="col-md-3">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<i
									className="bi bi-card-text"
									style={{
										fontSize: "2.5rem",
										color: 'var(--tgh-blue-light)',
										marginBottom: "1rem",
										display: "block",
									}}></i>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Keep Hospital Card Safe
								</h4>
							</div>
						</div>
						<div className="col-md-3">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<i
									className="bi bi-signpost"
									style={{
										fontSize: "2.5rem",
										color: 'var(--tgh-blue-light)',
										marginBottom: "1rem",
										display: "block",
									}}></i>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Follow Signs
								</h4>
							</div>
						</div>
						<div className="col-md-3">
							<div
								className="text-center p-4"
								style={{
									backgroundColor: "#f8f9fa",
									borderRadius: "8px",
									height: "100%",
								}}>
								<i
									className="bi bi-question-circle"
									style={{
										fontSize: "2.5rem",
										color: 'var(--tgh-blue-light)',
										marginBottom: "1rem",
										display: "block",
									}}></i>
								<h4
									style={{
										fontSize: "1.2rem",
										fontWeight: "600",
										color: "#000",
										marginBottom: "0.5rem",
									}}>
									Ask for Help
								</h4>
							</div>
						</div>
					</div>
				</div>

				{/* Contact Information */}
				<div
					ref={(el) => addToRefs(el, 12)}
					className={`scroll-fade-in ${visibleSections.has(12) ? "visible" : ""}`}>
					<h2
						className="mb-4"
						style={{
							fontSize: "2.5rem",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontFamily: "Georgia, serif",
							lineHeight: "1.2",
						}}>
						Contact Information
					</h2>
					<p
						className="mb-4"
						style={{ fontSize: "1.1rem", color: "#333", lineHeight: "1.6" }}>
						<strong>Tema General Hospital</strong>
						<br />
						<a
							href="https://maps.app.goo.gl/fYCxAzFS3JNGUKnNA"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: 'var(--tgh-blue-light)', textDecoration: "none" }}>
							Tema Community 12
						</a>
					</p>
					<p
						style={{
							fontSize: "1.1rem",
							color: "#333",
							lineHeight: "1.6",
							marginBottom: "2rem",
						}}>
						For general inquiries, please{" "}
						<Link
							to="/contact"
							style={{ color: 'var(--tgh-blue-light)', textDecoration: "none" }}>
							contact the hospital administration
						</Link>{" "}
						or information desk.
					</p>
					<div
						className="p-4"
						style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
						<p
							className="mb-0 fw-bold"
							style={{ fontSize: "1.2rem", color: "#000" }}>
							Thank you for choosing Tema General Hospital.
						</p>
						<p className="mb-0" style={{ fontSize: "1.1rem", color: "#333" }}>
							Your health and safety are our priority.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}

export default PatientVisitorGuide;
